import {Record} from 'immutable';

const Participant = Record({
    id: null,
    cpf: null,
    name: null,
    badge: null,
    coursewareId: null,
    status: null,
    pacote: null,
    usualName: null,
});

export default Participant;



// WEBPACK FOOTER //
// src/domain/Participant.js